<template>
  <div>
    <div class="tim_left">
      <!-- <div @click="leftChange(index)" class="itemimg " v-for="(item, index) in leftlist" :key="index">
        <div class="t" v-if="nowindex == index"></div>
        <img :src="item.imgurl" alt="" srcset="">
      </div> -->

      <div class="itemimg" @click="leftChange(0)">
        <el-badge :value="xtxiaonum" class="item" :hidden="xtxiaonum == 0 ? true : false">
          <img :src="leftlist[0].imgurl" alt="" srcset="">
        </el-badge>
        <div class="t" v-if="leftindex == 0"></div>
      </div>
      <div class="itemimg" @click="leftChange(1)">
        <el-badge :value="xiaonum" class="item" :hidden="xiaonum == 0 ? true : false">
          <img :src="leftlist[1].imgurl" alt="" srcset="">
        </el-badge>
        <div class="t" v-if="leftindex == 1"></div>
      </div>
      <div class="itemimg" @click="leftChange(2)">
          <img :src="leftlist[2].imgurl" alt="" srcset="">
        <div class="t" v-if="leftindex == 2"></div>
      </div>
      <!-- <div class="itemimg" @click="leftChange(3)">
          <img :src="leftlist[3].imgurl" alt="" srcset="">
        <div class="t" v-if="leftindex == 3"></div>
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    leftindex: {
      type: Number,
      default: 1
    }
  },
  name: '',
  computed: {
    ...mapState(['xiaonum', 'xtxiaonum'])
  },
  data() {
    return {
      leftlist: [
        { id: 1, imgurl: require('../../assets/tim/t1.png') },
        { id: 2, imgurl: require('../../assets/tim/t2.png') },
        { id: 3, imgurl: require('../../assets/tim/t3.png') },
        { id: 4, imgurl: require('../../assets/tim/t7.png') },
      ],
      nowindex: 1
    }
  },
  watch: {
    leftindex: {
      handler(newVal, oldVal) {
        //监听info对象变化
        if (newVal) {
          this.nowindex = this.leftindex
        }
      },
      deep: true, //深度监听
      immediate: true
    }
  },
  methods: {
    //最左侧使用方法
    leftChange(index) {
      this.nowindex = index
      this.$emit("leftChange", index)
    },
  },
}
</script>
<style lang='scss' scoped>
.tim_left {
  border-right: 1px solid #eee;
  width: 79px;
  height: 100%;
  .itemimg {
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    position: relative;

    img {
      width: 24px;
      height: 24px;
    }
  }

  .d {
    position: absolute;
    font-size: 12px;
    color: #fff;
    background-color: red;
    text-align: center;
    border-radius: 50%;
    padding: 1px 6px;
    text-align: center;
    right: 6px;
    top: 8px;
  }

  .t {
    width: 4px;
    height: 60px;
    background-color: #FFDB0C;
    position: absolute;
    left: 0%;
  }
}
</style>